export default __webpack_public_path__ + "static/media/empathy-lg.28d414d4.jpg";